module.exports = __webpack_public_path__ + "static/media/ETHICAL_DILEMMAS.e2dc0691.png";